import { useState } from 'react';
import { useWebContainer } from '../providers/WebContainerProvider';
import isEqual from 'lodash/isEqual';

export function IndexPage() {
    const { url, loading, instanceExists, createInstance } = useWebContainer();

    const [toggleInstance, setToggleInstance] = useState(filesTest);
    return null; // Return null for now since dont have licence to use webcontainers in prod....
    if (loading) {
        return <p>loading</p>;
    }
    return (
        <p>
            <button
                onClick={() => {
                    const files = isEqual(toggleInstance, filesTest)
                        ? filesTest2
                        : filesTest;
                    setToggleInstance(files);
                    createInstance(files);
                }}
            >
                Toggle instance
            </button>
            {instanceExists && <iframe src={url} />}
        </p>
    );
}

const filesTest = {
    'index.js': {
        file: {
            contents: `
  import express from 'express';
  const app = express();
  const port = 3111;
  
  app.get('/', (req, res) => {
    res.send('Welcome to a WebContainers app! 🥳');
  });
  
  app.listen(port, () => {
    console.log(\`App is live at http://localhost:\${port}\`);
  });`,
        },
    },
    'package.json': {
        file: {
            contents: `
  {
    "name": "example-app",
    "type": "module",
    "dependencies": {
      "express": "latest",
      "nodemon": "latest"
    },
    "scripts": {
      "dev": "nodemon --watch './' index.js"
    }
  }`,
        },
    },
};

const filesTest2 = {
    'index.js': {
        file: {
            contents: `
  import express from 'express';
  const app = express();
  const port = 3111;
  
  app.get('/', (req, res) => {
    res.send('Welcome to a WebContainers app! WITH NEW CONTENT and shit! 🥳');
  });
  
  app.listen(port, () => {
    console.log(\`App is live at http://localhost:\${port}\`);
  });`,
        },
    },
    'package.json': {
        file: {
            contents: `
  {
    "name": "example-app",
    "type": "module",
    "dependencies": {
      "express": "latest",
      "nodemon": "latest"
    },
    "scripts": {
      "dev": "nodemon --watch './' index.js"
    }
  }`,
        },
    },
};
